export const paymentOptions = {
  FULL: 'full',
  DEFERRED: 'deferred',
};
